import InterviewEnding from './InterviewEnding.component';

export default InterviewEnding;
